import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { successToast, errorToast } from '../Utils/toast';
import { closeModal } from '../redux/features/modalSlice';
import {
  getStaffList,
} from "../redux/services/Staff Services/Staff.Services";
import { useNavigate } from 'react-router';

const AssignLeadsModal = ({ data }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedStaff, setSelectedStaff] = useState('');
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(false);
  const [staffLoading, setStaffLoading] = useState(true);
  const { leadIds, onAssign, isLoading } = data || {};
  const [isMinimized, setIsMinimized] = useState(false);
  const fetchStaff = async () => {
    try {
      setStaffLoading(true);
      const res = await getStaffList();
      const staffData = res?.data || res?.staff || [];
      setStaff(Array.isArray(staffData) ? staffData : []);
    } catch (error) {
      console.error("Error fetching staff:", error);
      errorToast(error?.response?.data?.message || "Failed to load staff members");
    } finally {
      setStaffLoading(false);
    }
  };

  useEffect(() => {
    fetchStaff();
  }, []);

  const handleAssign = async () => {
    if (!selectedStaff) {
      errorToast('Please select a staff member');
      return;
    }

    if (onAssign) {
      try {
        await onAssign(selectedStaff);
        if (!isLoading) {
          dispatch(closeModal());
        }
      } catch (error) {
        console.error("Assignment error:", error);
        errorToast(error?.response?.data?.message || "Assignment failed");
      }
    }
  };

  const handleClose = () => {
    if (!isLoading) {
      dispatch(closeModal());
    }
  };
if (isMinimized) {
  return (
    <div
      className="position-fixed shadow rounded bg-primary text-white p-3"
      style={{
        bottom: "20px",
        right: "20px",
        zIndex: 99999,
        minWidth: "250px",
      }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <span>
          Assign Leads ({leadIds?.length || 0})
        </span>

        <div>
          <button
            className="btn btn-sm btn-light me-1"
            onClick={() => setIsMinimized(false)}
          >
            □
          </button>

          <button
            className="btn btn-sm btn-danger"
            onClick={() => dispatch(closeModal())}
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
}
  return (
    <div className="assign-leads-modal">
      <div className="assign-leads-content">
        {/* <div className="mb-3 d-flex gap-2">
          <p className="text-muted">
            Selected Leads: <strong>{leadIds?.length || 0}</strong>
          </p>
                <button
            className="btn btn-primary"
            onClick={() => navigate("/add-staff")}
            // onClick={() =>
            //   dispatch(
            //     openModal({
            //       type: "add-staff",
            //       title: "Add Staff",
            //       data: {
            //       refreshData: () => fetchStaff(),
            //       },
            //     })
            //   )
            // }

          >
            Add Employee
          </button>
        </div> */}
<div className="d-flex justify-content-between align-items-center mb-3">
  <p className="text-muted mb-0">
    Selected Leads: <strong>{leadIds?.length || 0}</strong>
  </p>

  <div className="d-flex gap-2">
  {/* <button
  type="button"
  className="btn btn-warning btn-sm"
  onClick={() => setIsMinimized(true)}
>
  —
</button> */}

    <button
      className="btn btn-primary btn-sm"
      onClick={() =>{
          dispatch(closeModal());
     navigate("/add-staff")}
      }
 
    >
      Add Employee
    </button>
  </div>
</div>

        <div className="mb-3">
          <label className="form-label fw-bold">
            Select Staff Member <span className="text-danger">*</span>
          </label>
          {staffLoading ? (
            <div className="text-center py-3">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading staff...</span>
              </div>
            </div>
          ) : staff.length === 0 ? (
            <div className="alert alert-warning">
              No staff members available. Please add staff first.
            </div>
          ) : (
            <select
              className="form-select"
              value={selectedStaff}
              onChange={(e) => setSelectedStaff(e.target.value)}
              disabled={isLoading || staffLoading}
            >
              <option value="">Choose staff member...</option>
              {staff.map((staffMember) => (
                <option key={staffMember.id || staffMember._id} value={staffMember.id || staffMember._id}>
                  {staffMember.name || staffMember.fullName} 
                  {staffMember.email ? ` (${staffMember.email})` : ''}
                  {staffMember.role ? ` - ${staffMember.role}` : ''}
                </option>
              ))}
            </select>
          )}
          {selectedStaff && (
            <div className="mt-2 text-success">
              <small>✓ Staff member selected</small>
            </div>
          )}
        </div>

        <div className="d-flex justify-content-end gap-2 mt-4">
          <button
            className="btn btn-secondary"
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleAssign}
            disabled={isLoading || !selectedStaff || staffLoading || staff.length === 0}
          >
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" />
                Assigning...
              </>
            ) : (
              `Assign ${leadIds?.length || 0} Lead${leadIds?.length > 1 ? 's' : ''}`
            )}
          </button>
        </div>

      </div>
    </div>



  );
};

export default AssignLeadsModal;